import React, { useEffect, useState } from 'react'
import AuthLayout from '../../layouts/AuthLayout'
import MobileView from '../../layouts/MobileView/MobileView'
import igLogo from "../../assets/images/ig-logo.png"
import { fetchIGHandleVerificationStatus, submitIGHandle } from '../../services/api/auth'
import ifAuthenticated from '../../utils/hoc/ifAuthenticated'
import { useNavigate } from 'react-router-dom'
import { getIntendedPath } from '../../redux-stores/store'
import { IG_HANDLE_VERIFICATION_ROUTE } from '../../constants/constants'

interface IGHandleVerificationData {
    is_verified: boolean,
    text: string,
    handle: string,
    receiver: string,
    cta_url: string
}

const ConnectIGHandle: React.FC = () => {

    const [handle, setIGHandle] = useState('');

    const [verificationData, setVerificationData] = useState<IGHandleVerificationData | null>(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const fetchHandle = async () => {
        try {
            setLoading(true);
            const response = await fetchIGHandleVerificationStatus();
            if (response.verification) {
                setVerificationData(response.verification);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const submit = async () => {
        try {
            setSubmitting(true);
            setError('');
            const response = await submitIGHandle({ handle })
            setVerificationData({ ...response, is_verified: false })
            navigate(IG_HANDLE_VERIFICATION_ROUTE);
        } catch (error: any) {
            console.log(error);
            setError(error?.response?.data?.message ?? 'There is some issue verifying your instagram handle, Please try again later. ');
        } finally {
            setSubmitting(false)
        }
    }

    useEffect(() => {
        fetchHandle();
    }, [])


    useEffect(() => {
        if (verificationData?.handle) {
            setIGHandle(verificationData.handle)
        }
    }, [verificationData?.handle])

    useEffect(() => {
        if (verificationData?.is_verified) {
            window.location.href = getIntendedPath();
            // navigate(getIntendedPath());
        }
    }, [verificationData?.is_verified])

    return (
        <MobileView>
            <AuthLayout
                leftAction={
                    error ? <a href="/logout" className="skip-and-verify"><i className="fa-solid fa-right-from-bracket me-1"></i>Logout</a> : null
                }
            >
                {
                    loading ? (
                        <div className="position-relative h-100 auth-content-inner">
                            <div className="loading d-flex justify-content-center h-100 align-items-center flex-column gap-2">
                                <div className="spinner-border color-blue-dark" role="status">
                                </div>
                                Loading...
                            </div>
                        </div>
                    ) : (
                        <div className="position-relative h-100 auth-content-inner">
                            <h4 className="pop w-100 text-center auth-heading">Connect Social Handle</h4>
                            <div className="w-100 d-flex justify-content-between">
                                <span className='social-handle-text text-center'>Link your social accounts to move ahead and unlock better opportunities</span>
                            </div>

                            <div className="auth-form gap-2">
                                <div className="auth-form-input-wrapper">
                                    <span><img src={igLogo} alt='IG Logo' className='ig-logo-inside-input-field' /></span>
                                    <input type="text"
                                        className="w-100"
                                        id="form1" placeholder="Enter Your Instagram Username"
                                        value={handle}
                                        onChange={e => setIGHandle(e.target.value)}
                                        autoComplete='off'
                                    />
                                </div>
                                {
                                    error ? <span className='text-danger lh-base'>{error}</span> : null
                                }
                            </div>
                            <div className="position-absolute w-100 bottom-1">
                                <button
                                    className="new-ui-btn w-100" disabled={!handle || submitting} onClick={submit}>{submitting ? 'Please wait...' : 'Continue'}</button>
                            </div>
                        </div>
                    )
                }
            </AuthLayout>
        </MobileView>
    )
}

export default ifAuthenticated(ConnectIGHandle)